/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function CustomSelect({
  options,
  value,
  label,
  size,
  className,
  error = false,
  helperText = '',
  fullWidth = false,
  IconComponent,
  ...props
}) {
  return (
    <FormControl
      size={size}
      className={className}
      error={error}
      fullWidth={fullWidth}
    >
      {label && <InputLabel>{label}</InputLabel>}
      <Select
        label={label}
        size={size}
        value={value}
        IconComponent={IconComponent || KeyboardArrowDownIcon}
        {...props}
      >
        {options?.map((x) => (
          <MenuItem
            key={x.value}
            value={x.value}
            disabled={x.disabled}
            onClick={(e) => e.stopPropagation()}
            css={css`
              ${x.hidden && 'display: none;'}
            `}
          >
            {x.icon ? (
              <div css={css({ display: 'flex', alignItems: 'center' })}>
                <ListItemIcon sx={{ minWidth: '32px' }}>{x.icon}</ListItemIcon>
                <ListItemText>{x.label}</ListItemText>
              </div>
            ) : (
              x.label
            )}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
